<template>
  <div>
    <div class="sub-container">
      <div class="contact-header">
        <el-radio-group v-model="orderType">
          <el-radio-button label="0">开方订单</el-radio-button>
          <el-radio-button label="2">审核订单</el-radio-button>
          <el-radio-button label="1">配送订单</el-radio-button>
        </el-radio-group>
        <el-date-picker style="margin-left: 50px; padding-left: 20px;" prefix-icon="none" v-model="orderMonth" @change="datePickerChange" value-format="yyyy-MM" align="center" type="month" placeholder="选择订单月份">
        </el-date-picker>
        <el-input class="input-circle" v-model="searchText" placeholder="患者姓名或手机号码"></el-input>
        <el-button class="button-search" round type="primary" @click="search" size="mini">搜 索</el-button>
      </div>
      <el-tabs class="tabs" type="card" v-if="orderType == 0" v-model="activeName1" @tab-click="handleClick">
        <el-tab-pane label="全部" name="-1"></el-tab-pane>
        <el-tab-pane label="待付款" name="0"></el-tab-pane>
        <el-tab-pane label="已完成" name="1"></el-tab-pane>
        <el-tab-pane label="已取消" name="2"></el-tab-pane>
      </el-tabs>
      <el-tabs class="tabs" type="card" v-if="orderType == 1" v-model="activeName2" @tab-click="handleFulClick">
        <el-tab-pane label="全部" name="-1"></el-tab-pane>
        <el-tab-pane label="草稿" name="100"></el-tab-pane>
        <el-tab-pane label="待付款" name="0"></el-tab-pane>
        <el-tab-pane label="待收货" name="1"></el-tab-pane>
        <el-tab-pane label="已完成" name="2"></el-tab-pane>
        <el-tab-pane label="已取消" name="3"></el-tab-pane>
      </el-tabs>
      <el-tabs class="tabs" type="card" v-if="orderType == 2" v-model="activeName3" @tab-click="handleCheckClick">
        <el-tab-pane label="全部" name="-1"></el-tab-pane>
        <el-tab-pane label="待审核" name="0"></el-tab-pane>
        <el-tab-pane label="审核中" name="1"></el-tab-pane>
        <el-tab-pane label="审核成功" name="2"></el-tab-pane>
        <el-tab-pane label="审核失败" name="3"></el-tab-pane>
      </el-tabs>
      <el-pagination v-if="orderType == '0' && totalPage > 10" class="pagination" background layout="prev, pager, next" :current-page="currentPageNo"
        @current-change="pageChange" :total="totalPage">
      </el-pagination>
      <el-table :data="currentOrderList" @row-click="tableClick" style="width: 1120px;margin-left: 40px;" :border="tableBorder" v-show="orderType == '0' && currentOrderList.length > 0">
        <el-table-column prop="typeText" align='left' label="开方类型" width="160">
        </el-table-column>
        <el-table-column prop="patientName" align='left' label="病人名称" width="160">
        </el-table-column>
        <el-table-column prop="patientPhoneNo" label="手机号" align='left' width="200">
        </el-table-column>
        <el-table-column prop="createTimeString" label="下单时间" align='left' width="220">
        </el-table-column>
        <el-table-column prop="price" label="订单价格" align='left' width="160">
        </el-table-column>
        <el-table-column prop="statusDesc" label="订单状态" align='left' width="120">
        </el-table-column>
      </el-table>
      <div class="empty-container" v-if="orderType == '0' && currentOrderList.length == 0">
        <span>{{emptyText}}</span>
      </div>

      <el-pagination v-if="orderType == '2' && totalCheckPage > 10" class="pagination" background layout="prev, pager, next" :current-page="currentCheckPageNo"
        @current-change="pageCheckChange" :total="totalCheckPage">
      </el-pagination>
      <el-table :data="currentCheckOrderList" @row-click="tableCheckClick" @mousedown.native="recordMouseDownPosition" style="width: 1120px;margin-left: 40px;" :border="tableBorder" v-show="orderType == '2' && currentCheckOrderList.length > 0">
        <el-table-column prop="typeText" align='center' label="开方类型" width="100">
        </el-table-column>
        <el-table-column prop="patientName" align='center' label="病人名称" width="110">
        </el-table-column>
        <el-table-column prop="patientPhoneNo" label="手机号" align='center' width="160">
        </el-table-column>
        <el-table-column prop="checkOrderId" label="审核订单号" align='center' width="240">
        </el-table-column>


        <el-table-column prop="payAmount" label="支付金额(元)" align='center' width="100">
        </el-table-column>
        <el-table-column prop="checkEndTime" label="审核完成时间" align='center' width="126">
        </el-table-column>
        <el-table-column prop="payStatusText" label="支付状态" align='center' width="120" @click.stop>
        </el-table-column>
        <el-table-column prop="checkStatusText" label="审核状态" align='center' width="120">
        </el-table-column>
      </el-table>
      <div class="empty-container" v-if="orderType == '2' && currentCheckOrderList.length == 0">
        <span>{{emptyCheckText}}</span>
      </div>

      <el-pagination v-if="orderType == '1' && totalFulPage > 10 && activeName2 != '100'" class="pagination" background layout="prev, pager, next" :current-page="currentFulPageNo"
        @current-change="pageFulChange" :total="totalFulPage">
      </el-pagination>
      <el-table :data="currentFulOrderList" @row-click="tableFulClick" style="width: 1120px;margin-left: 20px;" :border="tableFulBorder" v-show="orderType == '1' && currentFulOrderList.length > 0 && activeName2 != '100'">
        <el-table-column prop="patientName" align='left' label="病人名称" width="90">
        </el-table-column>
        <el-table-column prop="patientPhoneNo" label="手机号" align='left' width="130">
        </el-table-column>
        <el-table-column prop="deliveryOrderId" label="订单号" align='left' width="210">
        </el-table-column>
        <el-table-column prop="typeText" label="处方类型" align='left' width="110">
        </el-table-column>
        <el-table-column prop="createTime" label="下单时间" align='left' width="180">
        </el-table-column>
        <el-table-column prop="deliveryName" label="配送中心" align='left' width="200">
        </el-table-column>
        <el-table-column prop="sumPrice" label="价格(元)" align='left' width="80">
        </el-table-column>
        <el-table-column prop="statusText" label="订单状态" align='left' width="90">
        </el-table-column>
      </el-table>

      <div class="empty-container" v-show="orderType == '1'&&currentFulOrderList.length == 0 && activeName2 != '100'">
        <span>{{emptyText}}</span>
      </div>
      <el-pagination v-if="orderType == '1' && totalDraftPage > 10 && activeName2 == '100'" class="pagination" background layout="prev, pager, next" :current-page="currentDraftPageNo"
        @current-change="pageDraftChange" :total="totalDraftPage">
      </el-pagination>
      <el-table :data="currentDraftList" @row-click="tableDraftClick" style="width: 1120px;margin-left: 40px;" :border="tableDraftBorder" v-show="orderType == '1' && currentDraftList.length > 0 && activeName2 == '100'">
        <el-table-column prop="recipientName" align='left' label="病人名称" width="100">
        </el-table-column>
        <el-table-column prop="recipientPhone" label="手机号" align='left' width="150">
        </el-table-column>
        <el-table-column prop="visitRecordId" label="开方订单号" align='left' width="220">
        </el-table-column>
        <el-table-column prop="createTime" label="保存时间" align='left' width="180">
        </el-table-column>
        <el-table-column prop="recipientAddress" label="配送地址" align='left' width="435">
        </el-table-column>
      </el-table>

      <div class="empty-container" v-show="orderType == '1'&&currentDraftList.length == 0 && activeName2 == '100'">
        <span>{{emptyText}}</span>
      </div>
    </div>
    <div style="margin-bottom: 20px;">{{orderTips}}</div>
    <el-dialog title="微信支付" :visible.sync="qrcodeVisble" width="360px" :close-on-click-modal='dialogClosable'>
        <div class="dialog-wrapper">
            <div id="qrcode"></div>
            <span class="qrcode-dialog-text">二维码过期了？<b @click="qrcodeRefresh">立即刷新</b></span>
        </div>
    </el-dialog>
  </div>

</template>

<script>
  let un_pay_status  = "0" //未支付
  let payed_status  = "1" //已支付
  let order_avaliable_status  = "2" //订单生效
  let prescripting_status  = "3" //配药中
  let expressing_status  = "4" //配送中
  let express_complete_status  = "5" //配送完成
  import WJTRadio from '@/components/widgets/wjt-radio.vue'
  import dateUtils from '../../js/date'
  import QRCode from 'qrcodejs2'
  export default {
    name:'orderList',
    components:{
        WJTRadio
    },
    data() {
      return {
        currentOrderList: [],
        currentCheckOrderList: [],
        currentFulOrderList: [],
        activeName1:'-1',
        activeName2:'-1',
        activeName3:'-1',
        orderType:'0',//0:开方  1：配送 2 审核
        orderMonth: '',
        tableBorder: false,
        tableCheckBorder: false,
        tableFulBorder: false,
        tableDraftBorder: false,
        currentPageNo: 1,
        currentCheckPageNo: 1,
        currentFulPageNo: 1,
        currentDraftPageNo: 1,
        pageSize:10,
        pageFulSize:10,
        pageCheckSize:10,
        pageDraftSize:10,
        totalPage: 1,
        totalCheckPage: 1,
        totalFulPage: 1,
        totalDraftPage: 1,
        searchText:'',
        emptyText: '您还没有订单',
        emptyCheckText: '您还审核没有订单',
        editable: false,
        confirmLoading: false,
        payType:{
                key:'',
                value:'微信支付',
                options:[
                    '公共账户',
                    '微信支付'
                ]
        },
        qrcodeVisble:false,
        outTradeNo:"",
        currentIndex:0,
        dialogClosable:false,
        showPopver:false,
        isSearch:false,
        currentDraftList:[],
        tipsDate:"",
        mouseDownX: 0,
        mouseDownY: 0,
        orderTips:"",
        clickThreshold: 5 // 阈值：5像素内的移动视为点击
      }
    },
    created() {
      this.tipsDate = dateUtils.generateNewDate()
      var data = this.$store.getters.getOrderData
      if(!this.utils.isEmptyObject(data)){
        this.activeName1 = data.activeName1
        this.activeName2 = data.activeName2
        this.activeName3 = data.activeName3
        this.orderType = data.orderType
        this.orderMonth = data.orderMonth
        this.currentPageNo = data.currentPageNo
        this.currentPageNo = data.currentCheckPageNo
        this.currentFulPageNo = data.currentFulPageNo
        this.currentDraftPageNo = data.currentDraftPageNo
        this.pageSize = data.pageSize
        this.pageSize = data.pageCheckSize
        this.pageFulSize = data.pageFulSize
        this.pageDraftSize = data.pageDraftSize
        this.totalPage = data.totalPage
        this.totalPage = data.totalCheckPage
        this.totalFulPage = data.totalFulPage
        this.totalDraftPage = data.totalDraftPage
        this.searchText = data.searchText
        this.currentIndex = data.currentIndex
        this.isSearch = data.isSearch
      }
      var userInfo = this.$store.getters.getUserInfo
      if(!this.utils.isEmptyObject(userInfo)){
          if(userInfo.doctor && userInfo.doctor.hospitalId == 101){
            this.showPopver = false
          }else{
            this.showPopver = true
          }
      }
      if(this.orderType == '0'){
        this.getOrderList()
      }else if(this.activeName2 == "100"){
        this.getDraftList()
      }else if(this.orderType == '2'){
        this.getCheckOrderList()
      }else{
        this.getFulOrderList()
      }
    },
    methods: {
      recordMouseDownPosition(e) {
        this.mouseDownX = e.clientX
        this.mouseDownY = e.clientY
      },
      search(){
        this.isSearch = true
        if(this.orderType == '0'){
          this.currentPageNo = 1
          this.getOrderList()
        }else if(this.orderType == '2'){
          this.currentCheckPageNo = 1
          this.getCheckOrderList()
        }else{
          this.currentFulPageNo = 1
          this.getFulOrderList()
        }
      },
      getOrderList() {
        var params = {}
        if(this.activeName1 =='-1'){
          params = {
            pageNum:this.currentPageNo,
            pageSize:this.pageSize,
            keyWord:this.isSearch?this.searchText:'',
            createTimeString:this.orderMonth
          }
        }else{
          params = {
            createTimeString: this.orderMonth,
            pageNum:this.currentPageNo,
            pageSize:this.pageSize,
            status:this.activeName1 == '-1'?'':this.activeName1,
            keyWord:this.isSearch?this.searchText:'',
          }
        }

        this.wjtHttp.get(this, '/api/health/v1/prescription/order', params, false, (res) => {
          var data = res.data
          if (data.code == 200) {
            var orderList = data.rows
            this.currentOrderList = orderList
            if(!this.utils.isEmptyStr(orderList)) {
              this.totalPage = Math.ceil(data.total / 10) * 10
              for(var i=0;i<orderList.length;i++){
                orderList[i].typeText = orderList[i].type == 'S'?'自拟组方':'智能开方'
                if(this.showPopver){
                  orderList[i].payType = {
                    key:'',
                    value:'微信支付',
                    options:[
                        '公共账户',
                        '微信支付'
                    ]
                  }
                }else{
                  orderList[i].payType = {
                    key:'',
                    value:'微信支付',
                    options:[
                        '微信支付'
                    ]
                  }
                }
              }
            } else if(this.currentPageNo == 1) {
              this.emptyText = "您当月没有订单"
              this.totalPage = 1
            }
          } else {
            this.$message({
              message: (data.msg && data.msg.length > 0) ? data.msg : '订单服务异常，请联系管理员',
              type: 'error'
            })
          }
        }, (err) => {
          console.log(err)
        })
      },
      getFulOrderList(){
        var status = ""
        if(this.activeName2  ==  '0'){
            status = un_pay_status
        }else if(this.activeName2 == '1'){
            status = payed_status+'_'+order_avaliable_status+"_"+prescripting_status+"_"+expressing_status
        }else if(this.activeName2 == '2'){
            status = express_complete_status
        }else if(this.activeName2 == '3'){
            status = "-1_-2_-3_-4_-5_-6"
        }else if(this.activeName2 == '-1'){
            status = "0_1_2_3_4_5_-1_-2_-3_-4_-5_-6"
        }
        this.wjtHttp.get(this, '/api/delivery/order/list', {
          pageNum:this.currentFulPageNo,
          pageSize:this.pageFulSize,
          status:status,
          patientName:this.isSearch?this.searchText:'',
          queryMonth:this.orderMonth
        }, true, (res) => {
          var data = res.data
          if (data.code == 200) {
            var orderList = data.rows
            this.currentFulOrderList = orderList
            if(!this.utils.isEmptyStr(orderList)) {
              this.totalFulPage = Math.ceil(data.total / 10) * 10
            } else if(this.currentFulPageNo == 1) {
              this.emptyText = "您当月没有订单"
              this.totalFulPage = 1
            }
          } else {
            this.$message({
              message: (data.msg && data.msg.length > 0) ? data.msg : '订单服务异常，请联系管理员',
              type: 'error'
            })
          }
        }, (err) => {
          console.log(err)
        })
      },
      getCheckOrderList(){
        var status = ""
        if(this.activeName3  ==  '0'){
            status = '0'
        }else if(this.activeName3 == '1'){
            status = '1'
        }else if(this.activeName3 == '2'){
            status = '2'
        }else if(this.activeName3 == '3'){
            status = '3'
        }
        var params = {
          pageNum:this.currentCheckPageNo,
          pageSize:this.pageCheckSize,
          patientName:this.isSearch?this.searchText:'',
          queryMonth:this.orderMonth
        }
        if(status != ""){
          params.status = status
        }
        this.wjtHttp.get(this, '/api/prescriptionCheck/v1/order/list',params , true, (res) => {
          var data = res.data
          if (data.code == 200) {
            this.orderTips = data.msg;
            var orderList = data.rows
            for(var i=0;i<orderList.length;i++){
              switch(orderList[i].checkStatus){
                case '0':
                  orderList[i].checkStatusText = "待提交审核"
                  break;
                case '1':
                  orderList[i].checkStatusText = "审核中"
                  break;
                case '2':
                  orderList[i].checkStatusText = "审核成功"
                  break;
                case '3':
                  orderList[i].checkStatusText = "审核失败"
                  break;
                default:
                  orderList[i].checkStatusText = "未知"
                  break;
              }
              switch(orderList[i].payStatus){
                case '0':
                  orderList[i].payStatusText = "未支付"
                  break;
                case '1':
                  orderList[i].payStatusText = "支付成功"
                  break;
                case '-6':
                  orderList[i].payStatusText = "支付失败"
                  break;
                case '99':
                  orderList[i].payStatusText = "支付中"
                  break;
                case '-1':
                  orderList[i].payStatusText = "取消交易"
                  break;
                case '-2':
                  orderList[i].payStatusText = "申请退款"
                  break;
                case '-3':
                  orderList[i].payStatusText = "退款中"
                  break;
                case '-4':
                  orderList[i].payStatusText = "已退款"
                  break;
                case '-5':
                  orderList[i].payStatusText = "已过期"
                  break;
                case '-7':
                  orderList[i].payStatusText = "退款失败"
                  break;
                default:
                  orderList[i].payStatusText = "未知"
                  break;
              }
            }
            this.currentCheckOrderList = orderList
            // var that = this;
            // setTimeout(() =>{
            //   that.$forceUpdate();
            // },1000);
            if(!this.utils.isEmptyStr(orderList)) {
              this.totalCheckPage = Math.ceil(data.total / 10) * 10
            } else if(this.currentCheckPageNo == 1) {
              this.emptyText = "您当月没有审核订单"
              this.totalChecklPage = 1
            }
          } else {
            this.$message({
              message: (data.msg && data.msg.length > 0) ? data.msg : '订单服务异常，请联系管理员',
              type: 'error'
            })
          }
        }, (err) => {
          console.log(err)
        })
      },
      getDraftList(){
        this.wjtHttp.get(this, '/api/delivery/order/draft/list', {
          pageNum:this.currentDraftPageNo,
          pageSize:this.pageDraftSize,
          patientPhoneNo:this.isSearch?this.searchText:'',
          queryMonth:this.orderMonth
        }, true, (res) => {
          var data = res.data
          if (data.code == 200) {
            var draftList = data.rows
            this.currentDraftList = draftList
            if(!this.utils.isEmptyStr(draftList)) {
              this.totalDraftPage = Math.ceil(data.total / 10) * 10
            } else if(this.currentDraftPageNo == 1) {
              this.emptyText = "您当月没有草稿"
              this.totalDraftPage = 1
            }
          } else {
            this.$message({
              message: (data.msg && data.msg.length > 0) ? data.msg : '获取草稿异常，请联系管理员',
              type: 'error'
            })
          }
        }, (err) => {
          console.log(err)
        })
      },
      handleClick(){
        this.currentPageNo = 1
        this.searchText = ''
        this.isSearch = false
        this.getOrderList()
      },
      handleFulClick(){
        this.currentFulPageNo = 1
        this.searchText = ''
        this.isSearch = false
        if(this.activeName2 == "100"){
          this.getDraftList()
        }else{
          this.getFulOrderList()
        }
      },
      handleCheckClick(){

        this.currentCheckPageNo = 1
        this.searchText = ''
        this.isSearch = false
        this.getCheckOrderList()
      },
      pageChange(pageNo) {
        this.currentPageNo = pageNo
        this.getOrderList()
      },
      pageFulChange(pageNo) {
        this.currentFulPageNo = pageNo
        this.getFulOrderList()
      },
      pageCheckChange(pageNo) {
        this.currentCheckPageNo = pageNo
        this.getCheckOrderList()
      },
      pageDraftChange(pageNo) {
        this.currentDraftPageNo = pageNo
        this.getDraftList()
      },
      tableClick(row,column,event){
        if(row.status == '1'){
          if(row.type == "P"){
            this.$router.push({
              path:'/prescription',
              query:{
                visitRecordId:row.visitRecordId,
                patientId:row.patientId
              }
            })
          }else{
            this.$router.push({
              path:'/handmadePrescriptionDetails',
              query:{
                visitRecordId:row.visitRecordId
              }
            })
          }

        }
      },
      tableFulClick(row,column,event){
        this.$router.push({
          path:'/fulfillmentOrder',
          query:{
            orderId:row.deliveryOrderId,
          }
        })
      },
      tableCheckClick(row,column,event){
        console.log("mouseDownX:"+this.mouseDownX);
        console.log("mouseDownY:"+this.mouseDownY);
        console.log("clientX:"+event.clientX);
        console.log("clientY:"+event.clientY);
        if(this.mouseDownX != 0 || this.mouseDownY != 0){
          // 计算鼠标移动距离
          const deltaX = Math.abs(event.clientX - this.mouseDownX)
          const deltaY = Math.abs(event.clientY - this.mouseDownY)
          console.log("deltaX:"+deltaX);
          console.log("deltaY:"+deltaY);
          // 如果移动距离超过阈值，视为选中文本操作
          if (deltaX > this.clickThreshold || deltaY > this.clickThreshold) {
            this.mouseDownX = event.clientX;
            this.mouseDownY = event.clientY;
            return
          }
        }

        this.$router.push({
                      path:'/prescription',
                      query:{
                        visitRecordId:row.visitRecordId,
                        patientId:row.patientId
                      }
                    })
      },
      tableDraftClick(row,column,event){
        sessionStorage.setItem("prescription",JSON.stringify({
          endDate:row.endDate,
          startDate:row.startDate,
          type:row.type,
          visitRecordId:row.visitRecordId
        }))
        this.$router.push({
          path:'/fulfillmentConfirm',
          query:{
            mode:1,
          }
        })
      },
      datePickerChange(value){
        this.orderMonth = value
        this.currentPageNo = 1
        this.isSearch = false
        if(this.orderType == '0'){
          this.getOrderList()
        }else if(this.orderType == '2'){
          this.getCheckOrderList()
        }else{
          this.getFulOrderList()
        }
      },
      pay(index){
        if(this.mInterval){
          clearInterval(this.mInterval)
        }
        this.currentIndex = index
        var order =  this.currentOrderList[index]
        var params = {
            productId:order.visitRecordId,
            orderType:1,
            tradeType:'NATIVE',
            payChannel:order.payType.value=='微信支付'?'1':'3'
        }
        this.wjtHttp.post(this,'/api/api/pay/0.1/unifiedOrder',params,false,(res)=>{
            var data = res.data
            this.payLoading = false
            if(data.code == 200){
                if(data.data.payChannel == 1 && !this.utils.isEmptyStr(data.data.qrcode)){
                  this.qrcodeVisble =  true
                  this.outTradeNo = data.data.outTradeNo
                  this.$nextTick(()=>{
                      if(this.mQrCode !=undefined && this.mQrCode !=null){
                          this.mQrCode.clear()
                          this.mQrCode.makeCode(data.data.qrcode)
                      }else{
                          this.mQrCode = new QRCode('qrcode', {
                              text: data.data.qrcode,
                              width: 256,
                              height: 256,
                              colorDark : "#000000",
                              colorLight : "#ffffff",
                              correctLevel : QRCode.CorrectLevel.H
                          });
                      }
                      this.getPayStatus();
                  })
                }else{
                  this.$message({
                      message:"支付成功",
                      type:'success'
                  })
                  this.getOrderList()
                }

            }else{
                this.$message({
                    message:(data.msg&&data.msg.length > 0)?data.msg:'支付异常，请联系管理员',
                    type:'error'
                })
            }
        },(err)=>{
            console.log(err)
            this.payLoading = false
        })
      },
      qrcodeRefresh(){
          this.pay(this.currentIndex)
      },
      getPayStatus(){
          if(this.mInterval != undefined && this.mInterval != null){
              clearInterval(this.mInterval)
          }
          this.mInterval = setInterval(()=>{
              var params = {
                  outTradeNo:this.outTradeNo
              }
              this.wjtHttp.post(this,'/api/api/pay/0.1/query/place/result',params,false,(res)=>{
              var data = res.data
              if(data.code == 200){
                  if(data.data == 1103){
                       this.$message({
                          message:"支付成功",
                          type:'success'
                      })
                      this.qrcodeVisble = false
                      this.getOrderList()
                      clearInterval(this.mInterval)
                  }
              }
          },(err)=>{
              console.log(err)
          })
          },3000)
      },
    },
    beforeDestroy() {
      if(this.mInterval){
        clearInterval(this.mInterval)
      }
      this.$store.commit('updateOrderData',{
        activeName1:this.activeName1,
        activeName2:this.activeName2,
        activeName3:this.activeName3,
        orderType:this.orderType,//0:开方  1：配送
        orderMonth: this.orderMonth,
        currentPageNo: this.currentPageNo,
        currentCheckPageNo: this.currentCheckPageNo,
        currentFulPageNo: this.currentFulPageNo,
        currentDraftPageNo: this.currentDraftPageNo,
        pageSize:this.pageSize,
        pageCheckSize:this.pageCheckSize,
        pageFulSize:this.pageFulSize,
        pageDraftSize:this.pageDraftSize,
        totalPage: this.totalPage,
        totalCheckPage: this.totalCheckPage,
        totalFulPage: this.totalFulPage,
        totalDraftPage: this.totalDraftPage,
        searchText:this.searchText,
        currentIndex:this.currentIndex,
        isSearch:this.isSearch
      })
    },
    beforeRouteLeave(to,from,next){
      if(to.name != 'Prescription' && to.name != 'fulfillmentOrder'){
        this.$store.commit('updateOrderData',{})
      }
      next()
    },
    watch:{
        searchText:function(val){
            if(this.utils.isEmptyStr(val)){
              this.isSearch = false
              if(this.orderType == '0'){
                this.currentPageNo = 1
                this.getOrderList()
              }else if(this.orderType == '2'){
                this.currentCheckPageNo = 1
                this.getCheckOrderList()
              }else if(this.activeName2 == '100'){
                this.currentDraftPageNo = 1
                this.getDraftList()
              }else{
                this.currentFulPageNo = 1
                this.getFulOrderList()
              }
            }
        },
        orderType:function(val){
          this.isSearch = false
          this.searchText = ''
          if(val == '0'){
            this.currentPageNo = 1
            this.getOrderList()
          }else if(val == '2'){
            this.currentCheckPageNo = 1
            this.getCheckOrderList()
          }else if(this.activeName2 == '100'){
            this.currentDraftPageNo = 1
            this.getDraftList()
          }else{
            this.currentFulPageNo = 1
            this.getFulOrderList()
          }
        }
    }
  }

</script>

<style scoped>
  .sub-container {
    width: 1150px;
    margin: auto auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    right: 20px;
    padding-bottom: 20px;
  }

  .contact-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 8px 12px;
    background: #F9F9F9;
    width: 1120px;
  }
  .input-circle{
      width: 260px;
      margin-left: 100px;
      height: 40px;
  }
  .tabs{
    width: 1120px;
    padding-left: 10px;
  }
  .button-search{
    height: 42px;
    width: 100px;
    margin-left: 20px;
  }
  .input-circle >>> input{
      border-radius: 30px;
      padding-left: 20px;
      padding-right: 20px;
  }
  .divider {
    width: 1120px;
    background: #EEEEEE;
    height: 1px;
  }

  .pagination {
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .empty-container {
    width: 100%;
    height: 500px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .empty-container>span {
    font-size: 20px;
    color: #AEAEAE;
  }

  .contact-dialog {
    border-radius: 10px;
  }

  .radio-button-one {
    margin-right: 50px;
  }

  .dialog-picker {
    width: 350px;
  }

  .address-picker1 {
    width: 350px;
  }

  .address-picker2 {
    width: 350px;
  }

  .dialog-form {
    width: 450px;
  }

  .dialog-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .btn-dialog-cancel {
    margin-right: 50px;
    width: 150px;
    border-radius: 30px;
    margin-top: 30px;
  }

  .btn-dialog-confirm {
    margin-left: 50px;
    width: 150px;
    border-radius: 30px;
    margin-top: 30px;
  }
  .dialog-wrapper{
      display: flex;
      flex-direction: column;
      align-items: center;
  }
  .qrcode-dialog-text{
      color: #333333;
      font-size: 20px;
      margin-top: 30px;
  }
  .qrcode-dialog-text>b{
      color:#156098;
      font-size: 20px;
      cursor: pointer;
  }
  .pay-form{
    position: relative;
    left: 174px;
    margin-top: 26px;
  }
</style>



// WEBPACK FOOTER //
// src/components/account/order.vue